export const NAME = "page-messages";

// Entity
export const ENTITY_REQUESTS = `${NAME}/ENTITY_REQUESTS`;

// Form
export const FORM_WRITE_MESSAGE = `${NAME}/WRITE_MESSAGE`;
